var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2784_3410)" } }, [
        _c("path", {
          attrs: {
            d: "M13.8066 13.2003C12.9865 11.7753 11.4465 10.8179 9.6875 10.8179H7.3125C5.55352 10.8179 4.01348 11.7753 3.19336 13.2003C4.49961 14.655 6.39219 15.5679 8.5 15.5679C10.6078 15.5679 12.5004 14.6513 13.8066 13.2003ZM-1 8.44287C-1 5.92331 0.000890136 3.50695 1.78249 1.72536C3.56408 -0.0562388 5.98044 -1.05713 8.5 -1.05713C11.0196 -1.05713 13.4359 -0.0562388 15.2175 1.72536C16.9991 3.50695 18 5.92331 18 8.44287C18 10.9624 16.9991 13.3788 15.2175 15.1604C13.4359 16.942 11.0196 17.9429 8.5 17.9429C5.98044 17.9429 3.56408 16.942 1.78249 15.1604C0.000890136 13.3788 -1 10.9624 -1 8.44287ZM8.5 9.03662C9.20862 9.03662 9.88823 8.75512 10.3893 8.25405C10.8904 7.75297 11.1719 7.07337 11.1719 6.36475C11.1719 5.65612 10.8904 4.97652 10.3893 4.47545C9.88823 3.97437 9.20862 3.69287 8.5 3.69287C7.79138 3.69287 7.11177 3.97437 6.6107 4.47545C6.10963 4.97652 5.82812 5.65612 5.82812 6.36475C5.82812 7.07337 6.10963 7.75297 6.6107 8.25405C7.11177 8.75512 7.79138 9.03662 8.5 9.03662Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2784_3410" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0 0.942871)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }